import styled from 'styled-components';
import { Box, Typography, Button } from '@mui/material';
import { fontSizes } from '../../../layouts/fontSizes';

export const FormHeader = styled(Typography)({
  fontSize: `${fontSizes.h4} !important`,
  fontWeight: 'bold',
  marginLeft: '3% !important',
  marginTop: '16px !important'
});

export const StyledButton = styled(Button).attrs({
  variant: 'contained',
  color: 'primary'
})({});

export const OutlinedButton = styled(Button).attrs({
  variant: 'outlined',
  size: 'small'
})({});

export const ButtonContainer = styled(Box)({
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'flex-end',
  width: '100%'
});

export const ViewEditWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'end',
  justifyContent: 'space-between',
  marginBottom: 16
});
